import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Chip } from '@mui/material';
import ViewDocument from '../../../../../shared-ui/ViewDocument/ViewDocument';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS } from '../../../../../routes/PartnersEnum';
import { getPartnerGuid, hasAuthourity } from '../../../../../lib/access.es6';


const ClaimDocuments = (props) => {

  const [viewDocumentUrl, setViewDocumentUrl] = React.useState(null);
  const [numPages, setNumPages] = React.useState(null);

  const classes = useStyle();
  const claimDocs = props.claimDocuments || [];

  const pendingChecklistDocs = (props.checklist || [])
    .filter(function (entry) { return !entry.uploaded })
    .map(function (entry) {
      return {
        description: entry.description,
        label: entry.required && entry.description.indexOf('*') === -1
          ? entry.description + ' *'
          : entry.description,
        status: entry.required ? 'missing' : 'optional'
      }
    })

  const result = [
    ...pendingChecklistDocs,
    ...claimDocs,
    { description: '', status: 'any other doc' }
  ];


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}  >
          <Grid container spacing={2} className={classes.claimdocswrapper}>
            <Grid item xs={12} sm={12} md={12}>

              <TableInc
                columns={[
                  {
                    title: 'Document  Name', field: 'description',
                    render: rowData => rowData.label || rowData.description
                  },
                  {
                    title: 'Status', field: 'created_At', render: rowData => rowData.status === 'optional'
                      ? <Chip size="small" variant="outlined" label={'not uploaded'} style={{ margin: '1px' }} />
                      : rowData.status === 'missing'
                      ? <Chip
                        size="small"
                        variant="outlined"
                        label={'missing'}
                        style={{
                          margin: '1px',
                          backgroundColor: "red",
                          color: "#fff"
                        }}
                      />
                      : (rowData.status === 'any other doc' ? 'upload any other doc'
                        : <Chip
                          size="small"
                          variant="outlined"
                          label={'uploaded'}
                          style={{
                            margin: '1px',
                            backgroundColor: "green",
                            color: "#fff"
                          }}
                        />)
                  },

                  {
                    title: 'Actions', field: 'created_At', render: rowData => {
                      return !(rowData.status === 'missing' || rowData.status === 'optional' || rowData.status === 'any other doc') ? <div className={classes.actionbtn}>

                        {(
                          (PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(getPartnerGuid()) && hasAuthourity('UPDATE_CLAIM')) ||
                          !PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(getPartnerGuid())
                        ) && (
                            <>
                              <Tooltip title="View Document">
                                <span onClick={() => setViewDocumentUrl(rowData.url)} style={{ cursor: "pointer" }} ><VisibilityIcon sx={{ color: " #4B7E34" }} /> </span>
                              </Tooltip>
                              <Tooltip title="Download Document">
                                <span style={{ cursor: "pointer", marginLeft: "10px" }} ><a href={rowData.url} download target='_blank' rel="noopener noreferrer" ><FileDownloadIcon sx={{ color: " #000" }} /></a> </span>
                              </Tooltip>
                              <Tooltip title="Delete Document">
                                <span style={{ cursor: "pointer", marginLeft: "5px" }} onClick={() => props.setClaimDocumentToDelete(rowData)} > <DeleteIcon sx={{ color: "#8F191C" }} /></span>
                              </Tooltip>
                            </>

                          )}


                      </div> :

                        <div className={classes.actionbtn}>

                          {(
                            (PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(getPartnerGuid()) && hasAuthourity('UPDATE_CLAIM')) ||
                            !PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS.includes(getPartnerGuid())
                          ) && (
                              <Tooltip title="Upload Document">
                                <span style={{ cursor: "pointer", marginLeft: "5px" }} onClick={() => {
                                  props.setDescription(rowData.description);
                                  props.openUploadDialog();
                                }} > <FileUploadIcon sx={{ color: "#000" }} /></span>
                              </Tooltip>

                            )}


                        </div>
                    }
                  },


                ]}
                data={
                  result
                }
                options={{
                  pageSize: 7,
                  showTitle: false,
                }
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ViewDocument
        title="Claim Document"
        open={viewDocumentUrl}
        close={() => setViewDocumentUrl(null)}
        viewDocumentUrl={viewDocumentUrl}
        numPages={numPages}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      />
    </>
  )
}

export default ClaimDocuments